import styled, { keyframes } from "styled-components";

export const slideUp = keyframes`
  from { opacity: 0; transform: translateY(50px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const Body = styled.div`
  font-family: "Poppins-Regular", sans-serif;
  background: linear-gradient(135deg, #1a1a1a 0%, #2c2c2c 50%, #1a1a1a 100%);
  color: #ffffff;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  /* Background Pattern */
  padding: 2rem;
  &&::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="25" cy="25" r="1" fill="%23ff6b35" opacity="0.1"/><circle cx="75" cy="75" r="1.5" fill="%23ff6b35" opacity="0.1"/><circle cx="50" cy="10" r="0.8" fill="%23ff6b35" opacity="0.1"/><circle cx="10" cy="60" r="1.2" fill="%23ff6b35" opacity="0.1"/><circle cx="90" cy="30" r="0.9" fill="%23ff6b35" opacity="0.1"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
    opacity: 0.3;
    z-index: 1;
  }
`;

export const Notification = styled.div`
  position: fixed;
  top: 20px;
  right: 20px;
  padding: 1rem 1.5rem;
  border-radius: 10px;
  color: #ffffff;
  font-weight: bold;
  z-index: 3000;
  transform: ${(props) => (props.$show ? "translateX(0)" : "translateX(300%)")};
  transition: transform 0.3s ease-in-out;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  &.success {
    background: #27ae60;
  }

  &.error {
    background: #e74c3c;
  }

  &.warning {
    background: #f39c12;
  }

  &.info {
    background: #3498db;
  }
`;

export const BackLink = styled.a`
  position: absolute;
  top: 2rem;
  left: 2rem;
  z-index: 100;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #ff6b35;
  font-weight: bold;
  padding: 0.8rem 1.5rem;
  border-radius: 25px;
  background: rgba(26, 26, 26, 0.8);
  border: 1px solid rgba(255, 107, 53, 0.3);
  text-decoration: none;
  transition: 0.3s;
  &:hover {
    background: #ff6b35;
    color: #fff;
    transform: translateX(-5px);
  }
`;

export const LoginContainer = styled.div`
  background: linear-gradient(
    135deg,
    rgba(26, 26, 26, 0.95),
    rgba(44, 44, 44, 0.95)
  );
  border-radius: 20px;
  padding: 25px;
  width: 100%;
  max-width: 450px;
  position: relative;
  z-index: 10;
  border: 2px solid rgba(255, 107, 53, 0.3);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5);
  animation: ${slideUp} 0.8s ease-out;
`;

export const AdminBadge = styled.div`
  background: linear-gradient(45deg, #ff6b35, #e55a2b);
  padding: 0.5rem 1.5rem;
  border-radius: 25px;
  font-weight: bold;
  text-transform: uppercase;
  display: inline-block;
  margin-bottom: 1.5rem;
`;

export const SecurityBox = styled.div`
  background: rgba(255, 107, 53, 0.1);
  border: 1px solid rgba(255, 107, 53, 0.3);
  border-radius: 10px;
  padding: 1rem;
  text-align: center;
  margin-bottom: 1.5rem;
  font-size: 12px;
`;

export const SecurityTitle = styled.div`
  color: #ff6b35;
  font-weight: bold;
  margin-bottom: 0.5rem;
  display: flex;
  justify-content: center;
  gap: 0.3rem;
  align-items: center;
  font-size: 14px;
`;

export const InputGroup = styled.div`
  margin-bottom: 0.5rem;
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const Label = styled.label`
  color: #ff6b35;
  font-size: 0.9rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
  display: block;
  text-transform: uppercase;
`;

export const Input = styled.input`
  width: 100%;
  padding: 1rem 1.5rem;
  background: rgba(26, 26, 26, 0.8);
  border: 2px solid ${(props) => (props.$error ? "#e74c3c" : "#333")};
  border-radius: 12px;
  color: #fff;
  font-size: 14px;
  &:focus {
    border-color: ${(props) => (props.$error ? "#e74c3c" : "#ff6b35")};
    box-shadow: 0 0 20px
      ${(props) =>
        props.$error ? "rgba(231, 76, 60, 0.3)" : "rgba(255, 107, 53, 0.3)"};
  }
`;

export const Relative = styled.div`
  position: relative;
`;

export const InputIcon = styled.div`
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  color: #ff6b35;
  cursor: pointer;
`;

export const RememberSection = styled.div`
  display: flex;

  align-items: center;
  font-size: 14px;
  margin-bottom: 1rem;
  margin-top: 1rem;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const Checkbox = styled.input`
  width: 18px;
  height: 18px;
  accent-color: #ff6b35;
  cursor: pointer;

  &:checked {
    background-color: #ff6b35;
  }
`;

export const CheckboxLabel = styled.label`
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  user-select: none;

  &:hover {
    color: #ff6b35;
  }
`;

export const LoginButton = styled.button`
  width: 100%;
  margin-top: 1.5rem;
  padding: 1.2rem;
  background: ${(props) =>
    props.$disabled
      ? "transparent"
      : "linear-gradient(45deg, #ff6b35, #e55a2b)"};
  border: ${(props) => (props.$disabled ? "1px solid #ff6b35" : "none")};
  border-radius: 12px;
  color: ${(props) => (props.$disabled ? "#ff6b35" : "#fff")};

  font-weight: bold;
  outline: none;
  cursor: ${(props) => (props.$disabled ? "not-allowed" : "pointer")};
  transition: 0.3s;
  position: relative;

  &:hover {
    box-shadow: ${(props) =>
      props.$disabled ? "none" : "0 10px 25px rgba(255, 107, 53, 0.4)"};
    transform: ${(props) => (props.$disabled ? "none" : "translateY(-3px)")};
  }
`;

export const Footer = styled.div`
  text-align: center;
  margin-top: 2rem;
  border-top: 1px solid #333;
  padding-top: 1rem;
  opacity: 0.55;
  font-size: 0.8rem;
`;

export const ErrorMessage = styled.div`
  background: rgba(231, 76, 60, 0.1);
  border: 1px solid #e74c3c;
  color: #e74c3c;
  padding: 0.8rem 1rem;
  border-radius: 8px;
  margin-bottom: 1rem;
  font-size: 0.9rem;
  text-align: center;
`;
